import React, { useEffect, useRef, useState } from 'react';
import grapesjs from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';

const LocalTest: React.FC = () => {
  const editorRef = useRef<HTMLDivElement>(null);
  const [status, setStatus] = useState('Initializing...');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!editorRef.current) return;

    const testGrapesJS = async () => {
      try {
        setStatus('Checking GrapesJS availability...');
        console.log('LocalTest: Checking GrapesJS availability...');
        
        if (typeof grapesjs === 'undefined') {
          throw new Error('GrapesJS library not available');
        }

        setStatus('Initializing GrapesJS editor...');
        console.log('LocalTest: Initializing GrapesJS editor...');

        const editor = grapesjs.init({
          container: editorRef.current as HTMLElement,
          height: '400px',
          width: 'auto',
          storageManager: false,
          blockManager: {
            appendTo: '.gjs-blocks-c',
            blocks: [
              {
                id: 'section',
                label: 'Section',
                category: 'Basic',
                content: '<section class="section"><h2>Test Section</h2><p>This is a test</p></section>',
              },
              {
                id: 'text',
                label: 'Text',
                category: 'Basic',
                content: '<div data-gjs-type="text">Insert your text here</div>',
              }
            ]
          }
        });

        setStatus('Loading test content...');
        console.log('LocalTest: Loading test content...');

        editor.setComponents(`
          <section class="section">
            <h1>🎉 GrapesJS React Test Success!</h1>
            <p>If you can see this content, GrapesJS is working perfectly in React!</p>
            <div style="background: #f8f9fa; padding: 20px; border-radius: 8px; border-left: 4px solid #007bff;">
              <h3>✅ Test Results:</h3>
              <ul>
                <li>GrapesJS library loaded successfully</li>
                <li>Editor initialized without errors</li>
                <li>Components rendered correctly</li>
                <li>React integration working</li>
              </ul>
            </div>
            <p><strong>Status:</strong> Ready for production deployment!</p>
          </section>
        `);

        setStatus('GrapesJS working perfectly!');
        setSuccess(true);
        console.log('LocalTest: GrapesJS initialized successfully!');

      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Unknown error';
        setError(errorMessage);
        setStatus('Error occurred');
        console.error('LocalTest: Error initializing GrapesJS:', err);
      }
    };

    testGrapesJS();
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ 
        padding: '20px', 
        marginBottom: '20px', 
        borderRadius: '8px',
        backgroundColor: error ? '#f8d7da' : success ? '#d4edda' : '#fff3cd',
        border: `1px solid ${error ? '#f5c6cb' : success ? '#c3e6cb' : '#ffeaa7'}`
      }}>
        <h2>🧪 Local GrapesJS React Test</h2>
        <p><strong>Status:</strong> {status}</p>
        {error && (
          <div style={{ color: '#721c24', marginTop: '10px' }}>
            <strong>Error:</strong> {error}
          </div>
        )}
        {success && (
          <div style={{ color: '#155724', marginTop: '10px' }}>
            <strong>✅ Success:</strong> GrapesJS is working perfectly in React!
          </div>
        )}
      </div>

      <div 
        ref={editorRef} 
        style={{ 
          border: '2px solid #007bff', 
          borderRadius: '8px',
          minHeight: '400px'
        }} 
      />
    </div>
  );
};

export default LocalTest;
